/**
 * @file The NotificationsFormComponent is used in the template of the ReassignFormComponent.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { NotificationsService } from '../notifications.service';
import { AlertsService } from '../../core/alerts.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBase } from '../../base/form/form.base';
import { ResourceService } from '../../resource.service';
/**
 * The NotificationsFormComponent is used in the template of the ReassignFormComponent.
 *
 * @export
 * @class NotificationsFormComponent
 * @extends {FormBase}
 */
var NotificationsFormComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsFormComponent, _super);
    /**
     * Constructs a FormComponent instance.
     * @param configurationsService The configuration service.
     * @param notificationsService The notifications service
     * @param route The activated route.
     * @param alertsService The alerts service.
     */
    function NotificationsFormComponent(notificationsService, route, router, alertsService, resourceService) {
        return _super.call(this, notificationsService, route, router, null, alertsService, resourceService) || this;
    }
    return NotificationsFormComponent;
}(FormBase));
export { NotificationsFormComponent };
